import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, component, data, key, ctx }: FormattersTypes) => {
  component.tag = 'span';

  let val = ctx.t('No data');
  
  if(data[key]===1){
    val = vtag('ui-icon',
      {
        props: {
          size: 12,
          icon: 'fas fa-check-square',
          color: 'var(--color-green)',
        },
        class: [],
      }
    )
  }

  if(data[key]===2){
    val = vtag('ui-icon',
      {
        props: {
          size: 12,
          icon: 'fas fa-square-xmark',
          color: 'var(--color-red)',
        },
        class: [],
      }
    )
  }

  return vtag('div', {class: 'class-name'}, [val]);
}